<template>
  <div>
    <el-header class="header">
      <header class="logo-warp">
        <img class="logo" src="@assets/menu-nav/logo.png" alt />
        <div class="title">重置密码</div>
      </header>
    </el-header>
    <el-main class="main">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="ruleForm">
        <el-form-item label prop="code" style="display:flex;align-items: center">
          <el-input placeholder="请输入短信验证码" v-model="ruleForm.code" style="width: 160px"></el-input>
          <el-button class="send-code" :class="{'disabled': (count !== 60 || !ruleForm.verify)}" @click="handleSend" :disabled="(count !== 60 || !ruleForm.verify)">{{count !== 60 ? count + '秒后重新发送' :  '重新发送'}}</el-button>
        </el-form-item>
        <el-form-item label prop="password">
          <el-input placeholder="请输入新密码" type="password" v-model="ruleForm.password"></el-input>
        </el-form-item>
        <el-form-item label prop="password_confirm">
          <el-input placeholder="请输入再次输入密码" type="password" v-model="ruleForm.password_confirm"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="default" @click="$router.back()">上一步</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确<span style="opacity: 0;">啊</span>定</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </div>
</template>
<script>
import { login } from '@/api';

export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,16}$/.test(value)) {
        callback(new Error('密码由6-16个字符组成，其中包含大写字母，小写字母，数字!'));
      } else {
        callback();
      }
    };
    const validateRePass = (rule, value, callback) => {
      if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (String(value).length !== 6) {
        callback(new Error('请输入短信验证码为6位！'));
        return;
      }
      callback();
    };
    return {
      count: 60,
      timer: null,
      ruleForm: {
        verify: '',
        mobile: '',
        password: '',
        password_confirm: '',
        code: ''
      },
      rules: {
        password: [
          { required: true, message: '请设置登录密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        password_confirm: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: validateRePass, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: validateCode, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    handleSend() {
      if (!this.ruleForm.verify) return;
      login.smsSend({
        mobile: this.ruleForm.mobile,
        verify: this.ruleForm.verify,
      })
        .then(res => {
          if (res.code === 10000) {
            this.count = this.count - 1;
            this.$message.success('短信验证码发送成功！');
            this.timer = setInterval(() => {
              if (this.count <= 0) {
                this.count = 60;
                clearInterval(this.timer);
              } else {
                this.count = this.count - 1;
              }
            }, 1000);
            return;
          }
          this.count = 60;
          this.$message.error(res.msg);
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          login.userResetPassword({
            repeatPassword: this.ruleForm.password_confirm,
            mobile: this.ruleForm.mobile,
            sms: this.ruleForm.code,
            password: this.ruleForm.password
          })
            .then(res => {
              if (res.code === 10000) {
                this.$message.success('密码修改成功，请重新登录！');
                this.$router.push({
                  path: '/login'
                });
                return;
              }
              this.$message.error(res.msg);
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  created() {
    this.ruleForm.mobile = window.localStorage.getItem('mobile');
    this.ruleForm.verify = window.localStorage.getItem('verify');
    this.handleSend();
  }
};
</script>
<style scoped>
.header {
  border-bottom: 1px solid #ededed;
}
.logo-warp {
  display: flex;
  height: 60px;
  align-items: center;
}
.logo {
  height: 60px;
}
.title {
  font-size: 22px;
  font-weight: 600;
  color: #9fa0a0;
}
.main {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 100px);
}
.ruleForm {
  width: 400px;
}
.send-code {
  float: right;
  background: rgba(71, 78, 96, 1);
  border-radius: 4px;
  color: #D4D6DA;
  border: 1px solid rgba(255, 255, 255, 1);
  font-size: 12px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
}
.disabled {
  opacity: .3;
}
</style>



// WEBPACK FOOTER //
// src/view/ResetPass/index.vue